export default __webpack_public_path__ + "static/media/blood1.7b7fcdf3.png";